/**
 * Scroll into view with adjustment to the sticky navigation bar
 * @param element - element to scroll to
 * @param bottom - if true, align the bottom of the element to the bottom of the window
 */
export const scrollIntoView = (element: HTMLElement, bottom?: boolean) => {
  const headerElement = document.querySelector('[class*=FullHeader_root]')

  let headerHeight = 0
  if (headerElement) {
    // check if header is sticky
    const headerStyle = window.getComputedStyle(headerElement)
    const isSticky =
      headerStyle.position === 'sticky' &&
      +headerStyle.top.replace('px', '') <= 0

    if (isSticky) {
      headerHeight = headerElement.clientHeight
    }
  }
  const elementPosition =
    element.getBoundingClientRect()[bottom ? 'bottom' : 'top']
  const elementHeight = element.clientHeight
  const offset =
    elementPosition +
    window.scrollY -
    headerHeight -
    (bottom ? window.innerHeight - elementHeight : 0)



  window.scrollTo({
    top: offset,
    behavior: 'smooth',
  })
}
